import {
  BoolFilter,
  SortManualJournalEntriesBy,
} from "gen/search/service/service_pb"
import { SortOrder } from "shared-ts/hooks/useSort/helpers"
import { WebUrl } from "shared-web/lib/webUrl"

export function adminManualJournalEntries(): WebUrl {
  return {
    pathname: `/admin/manual-journal-entries`,
    query: {
      status: BoolFilter.TRUE.toString(),
      sort: SortManualJournalEntriesBy.ACCOUNTED_AT.toString(),
      order: SortOrder.Descending,
    },
  }
}

export function adminManualJournalEntry(id: string): WebUrl {
  return {
    pathname: `/admin/manual-journal-entries/${id}`,
  }
}

export function adminNewManualJournalEntry(duplicateFromId?: string): WebUrl {
  return {
    pathname: `/admin/manual-journal-entries/new`,
    query: duplicateFromId ? { duplicateFrom: duplicateFromId } : undefined,
  }
}

export function adminEditManualJournalEntry(id: string): WebUrl {
  return {
    pathname: `/admin/manual-journal-entries/${id}/edit`,
  }
}
